module.exports = __webpack_public_path__ + "static/media/Tile Image - Sero Premium.7a202d9b.png";